export default __webpack_public_path__ + "static/bigminer-qr-1ce46e0f264bc452e222c4d5318f29bb.png";